import { Col } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $CardContainer = styled.div`
  margin-top: ${spacing('xxl')};
`;

export const $Col = styled(Col)`
  margin-top: 0;
`;
